(function (globalScope) {
  const ENGRAVING_TEXT_PROPERTY = 'Engraving Text';
  const BUNDLE_ID_PROPERTY = '_bundle_id';
  const SERVICE_FLAG_PROPERTY = '_is_engraving_service';

  function normalizePositiveInteger(value) {
    const normalizedValue = Number.parseInt(value, 10);

    if (!Number.isFinite(normalizedValue) || normalizedValue < 1) {
      return 1;
    }

    return normalizedValue;
  }

  function createEngravingBundleId({ now = Date.now, random = Math.random } = {}) {
    const timestamp = typeof now === 'function' ? now() : now;
    const randomValue = typeof random === 'function' ? random() : random;
    const token = Math.floor(Math.max(0, Number(randomValue) || 0) * 1e8)
      .toString(36)
      .padStart(5, '0');

    return `engraving-${timestamp}-${token}`;
  }

  function buildMainLineItemFromEntries(entries) {
    const lineItem = {
      quantity: 1,
      properties: {},
    };

    for (const [name, value] of entries || []) {
      if (name === 'id') {
        lineItem.id = Number.parseInt(value, 10);
        continue;
      }

      if (name === 'quantity') {
        lineItem.quantity = normalizePositiveInteger(value);
        continue;
      }

      if (name === 'selling_plan' && value) {
        lineItem.selling_plan = value;
        continue;
      }

      const propertyMatch = /^properties\[(.+)\]$/.exec(name);
      if (propertyMatch) {
        lineItem.properties[propertyMatch[1]] = value;
      }
    }

    if (!Number.isFinite(lineItem.id) || lineItem.id < 1) {
      throw new Error('Main product variant is required to build the engraving bundle.');
    }

    if (Object.keys(lineItem.properties).length === 0) {
      delete lineItem.properties;
    }

    return lineItem;
  }

  function buildEngravingBundleItems({
    mainItemEntries,
    engravingVariantId,
    engravingText,
    engravingTextProperty = ENGRAVING_TEXT_PROPERTY,
    bundleId = createEngravingBundleId(),
  }) {
    const mainItem = buildMainLineItemFromEntries(mainItemEntries);
    const normalizedEngravingVariantId = Number.parseInt(engravingVariantId, 10);
    const normalizedEngravingText = typeof engravingText === 'string' ? engravingText.trim() : '';
    const normalizedEngravingTextProperty =
      typeof engravingTextProperty === 'string' && engravingTextProperty.trim()
        ? engravingTextProperty.trim()
        : ENGRAVING_TEXT_PROPERTY;

    if (!Number.isFinite(normalizedEngravingVariantId) || normalizedEngravingVariantId < 1) {
      throw new Error('Engraving service variant is required to build the engraving bundle.');
    }

    if (!normalizedEngravingText) {
      throw new Error('A saved engraving text is required to build the engraving bundle.');
    }

    return [
      {
        ...mainItem,
        properties: {
          ...(mainItem.properties || {}),
          [normalizedEngravingTextProperty]: normalizedEngravingText,
          [BUNDLE_ID_PROPERTY]: bundleId,
        },
      },
      {
        id: normalizedEngravingVariantId,
        quantity: mainItem.quantity,
        properties: {
          [BUNDLE_ID_PROPERTY]: bundleId,
          [SERVICE_FLAG_PROPERTY]: 'true',
        },
      },
    ];
  }

  function buildEngravingBundlePayload(input) {
    return {
      items: buildEngravingBundleItems(input),
    };
  }

  const api = {
    ENGRAVING_TEXT_PROPERTY,
    BUNDLE_ID_PROPERTY,
    SERVICE_FLAG_PROPERTY,
    createEngravingBundleId,
    buildMainLineItemFromEntries,
    buildEngravingBundleItems,
    buildEngravingBundlePayload,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  globalScope.BelvansEngravingFlow = api;
})(typeof window !== 'undefined' ? window : globalThis);
